import React, { useState, useEffect } from "react";

const FloatingButtons = () => {
  const [showButtons, setShowButtons] = useState(false); // État pour gérer la visibilité des boutons

  // Gestion du clic sur le bouton WhatsApp
  const handleWhatsAppClick = () => {
    window.open("https://wa.me/+33 6 65 32 87 71", "_blank");
  };

  // Gestion du clic sur le bouton "Remonter"
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // Écouteur de défilement pour afficher/masquer les boutons
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setShowButtons(true); // Afficher les boutons après 100px de défilement
      } else {
        setShowButtons(false); // Masquer les boutons
      }
    };

    window.addEventListener("scroll", handleScroll); // Ajouter l'écouteur
    return () => window.removeEventListener("scroll", handleScroll); // Nettoyer l'écouteur
  }, []);

  return (
    <>
      {showButtons && (
        <div className="fixed bottom-4 right-4 flex gap-2 z-50">
          {/* Bouton WhatsApp */}
          <button
            onClick={handleWhatsAppClick}
            className="bg-green-500 text-white p-2 rounded-full shadow-lg hover:bg-green-600 transition-colors duration-300"
          >
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
              alt="WhatsApp"
              className="w-6 h-6"
            />
          </button>

          {/* Bouton "Remonter" */}
          <button
            onClick={scrollToTop}
            className="bg-blue-500 text-white p-2 rounded-full shadow-lg hover:bg-blue-600 transition-colors duration-300 w-8 h-8 flex items-center justify-center"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" />
            </svg>
          </button>
        </div>
      )}
    </>
  );
};

export default FloatingButtons;